// Mixins
import Vue from 'vue';
import {generate_CHECK_DUPLICATION} from "../../graphql/queries/util";


/**
 * checkDuplication
 * @mixin
 *
 * Used to add check duplication functionality to components
 * returns true if found duplicate
 */

export default Vue.extend({
    name: 'checkDuplication',
    methods:{
        async checkDuplication(table, condition){
            let response = await this.$apollo.query({
                query: generate_CHECK_DUPLICATION(table),
                variables: { condition }
            })
            return Promise.resolve(response.data[table].length !== 0);
        }
    }
});
